export default __webpack_public_path__ + "images/models/f07dbcfb7e70d3f64d418291b9e71055.usdz";